module.exports = __webpack_public_path__ + "img/warning.234df514.svg";